import React from "react";
import PropTypes from "prop-types";

const propTypes = {
  status: PropTypes.string,
};

const SmallStatusBadge = (props) => {
  return (
    <>
      <strong>
        {props.status == "open" && <span className="badge rounded-pill open ">{"O"}</span>}
        {props.status == "pending" && <span className="badge rounded-pill hold ">{"H"}</span>}
        {props.status === "closed" && <span className="badge rounded-pill closed">{"C"}</span>}
      </strong>
    </>
  );
};

SmallStatusBadge.propTypes = propTypes;

export default SmallStatusBadge;
